import React from 'react';
import t from 'prop-types';
import Pestana from './pestana';

var PestanaTitulo = function PestanaTitulo(_ref) {
  var boton = _ref.boton,
      onBoton = _ref.onBoton;
  var clases = ['botonTitulo'];
  return React.createElement(Pestana, {
    boton: boton,
    clases: clases
  });
};

PestanaTitulo.propTypes = process.env.NODE_ENV !== "production" ? {
  boton: t.object,
  onBoton: t.func
} : {};
export default PestanaTitulo;